jQuery(document).ready(function($){
	$(".hamburger").click(function(){
		$("html, body").animate( { scrollTop: 0 } );
	});
});